import typeToReducer from 'type-to-reducer';
import { substractDays } from 'datesHelper.js';
import {
  CHANGE_DATE_BY_TYPE,
  FETCH_FREEBET_LIST,
  SET_CURRENT_PAGE,
  CHANGE_ACTIVE_TAB,
  RESET_TO_INITIAL_STATE,
} from 'accountFreebetActions.js';

let initialState = {
  isPending: true,
  error: null,
  startDate: substractDays(new Date(), 1),
  endDate: new Date(),
  freebets: {
    active: {
      currentPage: 0,
      data: [],
      isNextPageAvailable: false,
    },
    history: {
      currentPage: 0,
      data: [],
      isNextPageAvailable: false,
    },
  },
  limit: 5,
  activeTab: 'active',
};

const accountFreebetsInitialState = { ...initialState };

export default typeToReducer(
  {
    [RESET_TO_INITIAL_STATE]: () => {
      return accountFreebetsInitialState;
    },
    [CHANGE_ACTIVE_TAB]: (state, { payload: { activeTab } }) => {
      return {
        ...state,
        freebets: {
          active: {
            ...state.freebets.active,
            currentPage: 0,
          },
          history: {
            ...state.freebets.history,
            currentPage: 0,
          },
        },
        activeTab,
      };
    },
    [CHANGE_DATE_BY_TYPE]: (state, { payload: { dateType, date } }) => {
      return {
        ...state,
        freebets: {
          active: {
            ...state.freebets.active,
            currentPage: 0,
          },
          history: {
            ...state.freebets.history,
            currentPage: 0,
          },
        },
        [dateType]: date,
      };
    },
    [SET_CURRENT_PAGE]: (state, { payload: { currentPage } }) => {
      return {
        ...state,
        freebets: {
          ...state.freebets,
          [state.activeTab]: { ...state.freebets[state.activeTab], currentPage },
        },
      };
    },
    [FETCH_FREEBET_LIST]: {
      PENDING: (state) => {
        return { ...state, isPending: true };
      },
      FAILURE: (state, { payload: { error } }) => {
        return { ...state, isPending: false, error };
      },
      SUCCESS: (state, { payload: { data, isNextPageAvailable } }) => {
        return {
          ...state,
          isPending: false,
          freebets: {
            ...state.freebets,
            [state.activeTab]: { ...state.freebets[state.activeTab], data, isNextPageAvailable },
          },
        };
      },
      FULFILLED: (state) => {
        return { ...state, isPending: false };
      },
    },
  },
  initialState
);
